<template>
    <div class="text-center">
        <div class="loading-overlay"></div>
        <div style="position: absolute; width: 100%; margin: auto; text-align: center;" class="lds-roller">
            <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Loading'
    }
</script>